<template>
  <div class="wrapper">
    <parallax class="page-header header-filter"></parallax>
    <div class="">
      <div class="section text-center t_step">
        <div class="container md-card">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Select Meeting Date</h2>
              <!-- <md-progress-bar
                class="md-primary"
                md-mode="buffer"
                :md-value="progressNum"
                :md-buffer="progressNum"
              ></md-progress-bar> -->
            </div>
            <md-steppers md-alternative md-linear :md-active-step.sync="active" :md-editable="false">
              <md-step id="first" md-label="First Step - Choose Meeting Dates" :md-editable="false" :md-done.sync="first">
              </md-step>
              <md-step id="second" md-label="Second Step - Select Room" :md-editable="false" :md-done.sync="second">
              </md-step>
              <md-step id="third" md-label="Third Step - Finish Information" :md-editable="false" :md-done.sync="third">
              </md-step>
            </md-steppers>
          </div>
        </div>
      </div>
      <div class="section text-center t_content">
        <md-card class="container">
          <div class="md-layout text-left">
            <div class="md-layout-item md-size-100">
              <div class="title">
                <h3>Choose Meeting Date</h3>
              </div>
            </div>
            <div class="md-layout-item md-size-50">
              <md-datepicker v-model="selectedStartDate" :md-disabled-dates="opt.timeArr">
                <label>Select date</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label for="period">Meeting Period</label>
                <md-select v-model="meetingPeriod" name="period" id="period">
                  <md-option value="" :disabled="opt.full">- select -</md-option>
                  <md-option value="1" :disabled="opt.full">Full Day</md-option>
                  <md-option value="2" :disabled="opt.am">Morning 7am - 1 pm</md-option>
                  <md-option value="3" :disabled="opt.pm">Evening 4pm - 12am</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-40">
              <md-field>
                <label for="setup">Meeting Hall Setup</label>
                <md-select v-model="meetingHallSetup" name="setup" id="setup">
                  <md-option value="1">Yes (add $50 Setup fees)</md-option>
                  <md-option value="2">No</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-field>
                <label for="setup">Long Tabe</label>
                <md-input v-model="longTable" type="number" v-number-only v-on:click.stop.prevent></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-field>
                <label for="setup">Round Table</label>
                <md-input v-model="roundTable" type="number" v-number-only v-on:click.stop.prevent></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-field>
                <label for="setup">Chairs</label>
                <md-input v-model="chairs" type="number" v-number-only v-on:click.stop.prevent></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100 text-right">
              <md-button
                href="javascript:void(0)"
                class="md-orange md-lg"
                v-on:click="getter()"
                :disabled="isOff"
                ><md-icon>send</md-icon>Check Availability
              </md-button>
            </div>
          </div>
        </md-card>
      </div>
    </div>
    <div class="cover" v-if="loadStatus">
      <md-progress-spinner :md-diameter="50" :md-stroke="5" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  // import HotelDatePicker from 'vue-hotel-datepicker'
  export default {
    prop: {
    },
    // components: {
    //   HotelDatePicker
    // },
    data: () => {
      return {
        active: 'first',
        loadStatus: true,
        first: false,
        second: false,
        third: false,
        id: 0,
        progressNum: 33,
        selectedStartDate: new Date(),
        selectedEndDate: '',
        date:'',
        myresult: [],
        selected: {},
        meetingPeriod: '',
        meetingHallSetup: 1,
        longTable: 0,
        roundTable: 0,
        chairs: 0,
        adult: 1,
        children: 0,
        resData: {},
        isOff: true,
        opt: {
          full: false,
          am: false,
          pm: false,
          timeArr: [],
          timeAll: []
        }
      }
    },
    directives: {
      numberOnly: {
        bind: function(el) {
          el.handler = function() {
            el.value = Number(el.value.replace(/\D+/, ''))
          }
          el.addEventListener('input', el.handler)
        },
        unbind: function(el) {
          el.removeEventListener('input', el.handler)
        }
      }
    },
    watch: {
      meetingPeriod: {
        handler (n, o) {
          //this.periodDisable()
          if (this.meetingPeriod !== '') {
            this.isOff = false
          } else {
            this.isOff = true
          }
        },
        deep: true
      }
    },
    methods: {
      // getData: function () {
      //   this.resData = this.$route.params
      //   return this.resData
      // },
      datePick: function () {
        // periodDisable
      },
      periodDisable: function () {
        let that = this
        this.opt.full = false
        this.opt.am = false
        this.opt.pm = false
        let tmp = []
        // console.log(that.selectedStartDate)
        for (let i = 0; i < that.opt.timeAll.length; i++) {
          if (new Date(that.opt.timeAll[i].c).getTime() === new Date(that.selectedStartDate).getTime()) {
            if (that.opt.timeAll[i].r.length === 6 && that.opt.timeAll[i].r.every((e) => {
              return e.indexOf('1') !== -1 || (e.indexOf('2') !== -1 && e.indexOf('3') !== -1)
            })) {
              that.opt.full = true
            }
            if (that.opt.timeAll[i].r.length === 6 && that.opt.timeAll[i].r.every((e) => {
              return e.indexOf('2') !== -1
            })) {
              that.opt.am = true
            }
            if (that.opt.timeAll[i].r.length === 6 && that.opt.timeAll[i].r.every((e) => {
              return e.indexOf('3') !== -1
            })) {
              that.opt.pm = true
            }
            // for (let j = 0; j < that.opt.timeAll[i].r.length; j++) {
            //   if (that.opt.timeAll[i].r[j].indexOf('1') !== -1 || (that.opt.timeAll[i].r[j].indexOf('2') !== -1 || that.opt.timeAll[i].r[j].indexOf('3') !== -1)) {
            //     that.opt.full = true
            //   }
            //   if (that.opt.timeAll[i].r[j].indexOf('2') !== -1) {
            //     that.opt.am = true
            //   }
            //   if (that.opt.timeAll[i].r[j].indexOf('3') !== -1) {
            //     that.opt.pm = true
            //   }
            // }
          }
        }
      },
      dbDate: function () {
        let that = this
        return axios.post('https://www.orangetreetx.com/cgi-bin/php/dbhs.php').then((res) => {
          if (res.data.result.length > 0) {
            that.resortArr(res.data.result)
          }
        }).catch((error) => {
        }).finally((res) => {

        })
      },
      fileDate: function () {
        let that = this
        return axios.post('https://www.orangetreetx.com/cgi-bin/php/ohs.php').then((res) => {
          let arr = [],temp, arr1 = [], arrFinal = [];
          arr = res.data.split('|FD Name:')
          for(let i = 1; i < arr.length; i++){
            arr[i] = arr[i].split('|')
            for(let j = 0; j < arr[i].length; j++){
              if(j == arr[i].length - 1 && i != arr.length - 1){
                temp = arr[i][j].substring(arr[i][j].length-9, arr[i][j].length)
                arr[i][j] = arr[i][j].substring(0,arr[i][j].length-9)
                
                arr1[i] = temp
              }else if (j == 3){
                arr[i][j] = arr[i][j].split(' ')
              }
            }
          }
          for(let i = 0; i < arr.length; i++){	
            if(i == 1){
              arr[i].push(arr[0].substring(arr[0].length - 9))
              arrFinal[i] = arr[i]
            }else if(i != 0 && i != 1){
              arr[i].push(arr1[(i-1)])
              arrFinal[i] = JSON.parse(JSON.stringify(arr[i]))
            }
          }
          that.showHistory(that.compareTime(arrFinal),0)
        }).catch((error) => {
        }).finally((res) => {
        })
      },
      resortArr: function (arr) {
        let obj = this.opt.timeAll
        let a1 = JSON.parse(JSON.stringify(arr))
        let i = 0, j = 0;
        while (i < a1.length) {
          if (!obj.some((item) => {
            if (item.c === a1[i].c) {
              if (!item.r.some((item) => {
                if (item[0] === a1[i].r) {
                  if (item.indexOf(a1[i].p) === -1) {
                    item.push(a1[i].p)
                  }
                }
                return item[0] === a1[i].r
              })) {
                item.r.push([a1[i].r, a1[i].p])
              }
            }
            return item.c === a1[i].c
          })) {
            obj.push({c:a1[i].c, r:[[a1[i].r, a1[i].p]]})
          }
          i++
        }
        // console.log(obj)
      },
      initDate: function () {
        let that = this
        this.opt.timeArr = []
        this.opt.timeAll = []
        axios.all([that.dbDate(), that.fileDate()]).then(
          axios.spread(function () {
            that.loadStatus = false
            for (let i = 0; i < that.opt.timeAll.length; i++) {
              for (let j = 0; j < that.opt.timeAll[i].r.length; j++) {
                if (that.opt.timeAll[i].r[j].indexOf('1') !== -1 || (that.opt.timeAll[i].r[j].indexOf('2') !== -1 && that.opt.timeAll[i].r[j].indexOf('3') !== -1)) {
                  if (that.opt.timeArr.indexOf(that.opt.timeAll[i].c) === -1) {
                    that.opt.timeArr.push(that.opt.timeAll[i].c)
                  }
                }
              }
            }
            // console.table('done', that.opt.timeAll, that.opt.timeArr)
          })
        )
      },
      showHistory: function (newArr, isAll) {
        let that = this
        let now = 0
        let day = new Date(), Year = day.getFullYear(), Month = day.getMonth()+1, Day = day.getDate(), CurrentDate = Year + "-"; 
        let tempArr = [], copyArr = [];
        if (Month >= 10 ){ 
          CurrentDate += Month + "-"; 
        } else { 
          CurrentDate += "0" + Month + "-"; 
        } 
        if (Day >= 10 ) { 
          CurrentDate += Day ; 
        } else { 
          CurrentDate += "0" + Day ; 
        } 
        if (isAll == 1) {
          now = 0;
        } else {
          now = parseInt(new Date(CurrentDate.replace(/-/g,'/')).getTime());
        }
        copyArr = JSON.parse(JSON.stringify(newArr))
        for(let i = 0; i < newArr.length; i++){
          tempArr[i] = new Array();
        }
        for(let n = 0; n < copyArr.length; n++){
          if(that.isPush(tempArr, copyArr[n]) == false){
            for(let i = 0; i < newArr.length; i++){
              if((new Date(newArr[i][3][2].replace(/-/g,'/')).getTime()) >= now && ((new Date(copyArr[n][3][2].replace(/-/g,'/')).getTime()) >= now)){
                if((new Date(newArr[i][3][2].replace(/-/g,'/')).getTime()) == (new Date(copyArr[n][3][2].replace(/-/g,'/')).getTime()) && newArr[i][3][3] == copyArr[n][3][3] && newArr[i][2] == copyArr[n][2]){
                  tempArr[n].push(JSON.parse(JSON.stringify(newArr[i])));
                }
              }
            }
          }else{
          }
        }
        let pstr = ''
        for (let i = 0; i < tempArr.length; i++){
          if (tempArr[i].length > 0){
            for (let j = 0; j < tempArr[i].length; j++) {
              if (tempArr[i][j][0].indexOf('No') != -1) {
                tempArr[i][j][0] = JSON.parse(JSON.stringify(tempArr[i][j][0].replace(', Canceled:No','')))
                pstr = tempArr[i][j][3][3].indexOf('Fullday') !== -1 ? '1' : (tempArr[i][j][3][3].indexOf('Day') !== -1 ? '2' : '3')
                if (!that.opt.timeAll.some((m) => {
                  if (m.c === tempArr[i][j][3][2]) {
                    if (!m.r.some((n) => {
                      if (n[0] === tempArr[i][j][2]) {
                        if (n.indexOf(pstr) === -1) {
                          n.push(pstr)
                        }
                      }
                      return n[0] === tempArr[i][j][2]
                    })) {
                      m.r.push([tempArr[i][j][2], pstr])
                    }
                  }
                  return m.c === tempArr[i][j][3][2]
                })) {
                  that.opt.timeAll.push({c:tempArr[i][j][3][2], r:[[tempArr[i][j][2],pstr]]})
                }
              }
            }
          }
        }
      },
      compareTime: function (e) {
        let newArr = []
        for (let i = 1; i < e.length; i++) {
          if (e[i][3][2].length >= 10) {
            newArr.push(e[i]);
          }
        }
        newArr.sort(this.sortTime)
        return newArr
      },
      sortTime: function (a, b) {
        let ca = 0,cb = 0;
        if (a[3][2].length > 2) {
          ca = new Date(a[3][2].replace(/-/g,'/')).getTime();
        }
        if (b[3][2].length > 2) {
          cb = new Date(b[3][2].replace(/-/g,'/')).getTime();
        }
        return ca - cb;
      },
      isPush: function (tempArr, copyArr) {
        let hasItem = false
        for (let j = 0; j < tempArr.length; j++) {
          if (tempArr[j].length > 0) {
            if ((new Date(tempArr[j][0][3][2].replace(/-/g,'/')).getTime()) == (new Date(copyArr[3][2].replace(/-/g,'/')).getTime()) && tempArr[j][0][3][3] == copyArr[3][3] && tempArr[j][0][2] == copyArr[2]) {
              hasItem = true
              break
            }
          }	
        }
        return hasItem
      },
      // getNightDate: function () {
      //   var tempDate = ''
      //   tempDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      //   this.selectedStartDate = new Date()
      //   // this.selectedStartDate = this.formateTime(tempDate, "yyyy-MM-dd")
      //   return this.selectedStartDate
      // },
      formateTime (times, pattern) {
        Date.prototype.Format = function (e) {
          var o = {
            "M+": this.getMonth() + 1,
            "d+": this.getDate(),
            "h+": this.getHours(),
            "m+": this.getMinutes(),
            "s+": this.getSeconds(),
            "q+": Math.floor((this.getMonth() + 3) / 3),
            "S": this.getMilliseconds()
          };
          if (/(y+)/.test(e)) {
            e = e.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
          }
          for (var k in o) {
            if (new RegExp("(" + k + ")").test(e)) {
              e = e.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
            }
          }
          return e
        } 
        var d = new Date(times).Format("yyyy-MM-dd hh:mm:ss")
        if (pattern) {
          d = new Date(times).Format(pattern)
        }
        return d.toLocaleString()
      },
      getter: function (e) {
        sessionStorage.setItem(this.id + "start", this.formateTime(this.selectedStartDate, "yyyy-MM-dd"));
        sessionStorage.setItem(this.id + "meetingPeriod", this.meetingPeriod);
        sessionStorage.setItem(this.id + "meetingHallSetup", this.meetingHallSetup);
        sessionStorage.setItem(this.id + "longTable", (typeof(this.longTable) == 'number' ? this.longTable : 0));
        sessionStorage.setItem(this.id + "roundTable", (typeof(this.roundTable) == 'number' ? this.roundTable : 0));
        sessionStorage.setItem(this.id + "chairs", (typeof(this.chairs) == 'number' ? this.chairs : 0));
        sessionStorage.setItem(this.id + "opt", JSON.stringify(this.opt));
        // console.log(this.formateTime(this.selectedStartDate, "yyyy-MM-dd"), this.meetingPeriod)
        // console.log('choose', this.id, sessionStorage.getItem(this.id + 'opt'))
        this.$router.push({name:'showMeetingList', params:{
          id: this.id,
          startDate: this.selectedStartDate,
          meetingPeriod: this.meetingPeriod,
          meetingHallSetup: this.meetingHallSetup,
          longTable: this.longTable,
          roundTable: this.roundTable,
          chairs: this.chairs
        }})
      }
    },
    created() {
      this.id = 'm' + new Date().getTime().toString() + Math.round(Math.random() * 1000)
      this.$material.locale.dateFormat = 'YYYY-MM-DD'
      this.initDate()
      // this.getNightDate()
    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .page-header {
    height: auto;
  }
  .t_main {
    height: 100%;
    position: relative;
  }
  .datepicker__clear-button svg {
    top: 6px !important;
    left: 12px !important;
  }
  .md-ripple > span {
    left: auto;
    width: auto;
  }
  .t_content {
    padding-top: 0px;
    .container {
      margin-top: 0px;
      padding: 20px 20px 60px 20px;
    }
  }
  .t_step{
    padding: 100px 0px 10px;
    h2{
      padding-top:20px;
    }
  }
  .cover {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
</style>
<style lang="scss">
  .md-steppers{
    width: 100%;
    button{
      background-color: #fff!important;
      border: none;
      box-shadow: none;
      &:hover, &:active, &:link{
        background-color: #fff!important;
        border: none;
        box-shadow: none;
        cursor: pointer;
      }
    }
  }
  .md-steppers-navigation{
    box-shadow: none!important;
  }
</style>